import { render } from "./MainBar.vue?vue&type=template&id=13dbee4b&scoped=true"
const script = {}

import "./MainBar.vue?vue&type=style&index=0&id=13dbee4b&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/topik-vue/topik-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13dbee4b"]])

export default __exports__